import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import Box from '@mui/material/Box';     
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage'; 
import Paper from '@mui/material/Paper';   
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';  
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter'; 
import useTheme from '@mui/material/styles/useTheme'; 
import visuallyHidden from '@mui/utils/visuallyHidden';
import "css/customDialog.css";
import PropTypes from 'prop-types';  

const headCellsAddress = [ 
  {
    id: 'licenseplate',
    numeric: false,
    disablePadding: false,
    label: 'Text_FORM_Vehicle_licenseplate',
    canOrder:false,
  },
  {
    id: 'defaultvehicle',
    numeric: false,
    disablePadding: false,
    label: 'Text_FORM_Vehicle_defaultvehicle',
    canOrder:true,
  } ,
  {
    id: 'tara',
    numeric: false,
    disablePadding: false,
    label: 'Text_FORM_Vehicle_tara',
    canOrder:true,
  },
  {
    id: 'pma',
    numeric: false,
    disablePadding: false,
    label: 'Text_FORM_Vehicle_pma',
    canOrder:true,
  },
  {
    id: 'checkpma',
    numeric: false,
    disablePadding: false,
    label: 'Text_FORM_Vehicle_checkpma',
    canOrder:true,
  },
  {
    id: 'defaultdriver',
    numeric: false,
    disablePadding: false,
    label: 'Text_FORM_Vehicle_driver',
    canOrder:true,
  }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
  
function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
        return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          key='edit'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {t('Button_Select')}
          </Typography>
        </TableCell>
        {headCellsAddress.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
    const { numTotRegVehicles, t,titleTable } = props; 
    return (
      <Toolbar>
      <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 20}} id="tableTitle" component="div">
        {titleTable} &nbsp;&nbsp;
      </Typography>
      <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
        {t('Text_Num_Reg')} {(numTotRegVehicles).toLocaleString('de-DE')} {t('Text_Of')}  {(numTotRegVehicles).toLocaleString('de-DE')}
      </Typography>
    </Toolbar>
  );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataGeneralSettings']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingTypesDIVehicles =(props)=>{
  const { dataVehicle,numTotRegVehicles,titleTable,selectStores,setFormForm,handleCloseDataEditVehicles} = props;
  const {t} = useTranslation(['listDataForms']);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataVehicle.length) : 0);
  const [countData,setCountData] = useState(dataVehicle.length);  

  useEffect(() => {
    if (dataVehicle.length !== countData || dataVehicle.length <= rowsPerPage) {
      setPage(0);
    }  
    setCountData(dataVehicle.length);
    setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataVehicle.length) : 0);
  }, [dataVehicle, rowsPerPage, page, countData]);
   
  
  
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const selectDefaultAddress = (row) => {
    switch (selectStores) {
      case "Opt_Tras": 
        setFormForm(formForm => ({
          ...formForm,
          default_opt_tras_licenseplate:row.licenseplate
        }));
        break;
      case "Ori_Tras": 
        setFormForm(formForm => ({
          ...formForm,
          default_ori_tras_licenseplate:row.licenseplate
        }));
        break;
      case "Aut_Tras": 
        setFormForm(formForm => ({
          ...formForm,
          default_aut_tras_licenseplate:row.licenseplate
        }));
        break;
      case "Dest_Tras": 
        setFormForm(formForm => ({
          ...formForm,
          default_dest_tras_licenseplate:row.licenseplate
        }));
        break;
      case "Aut_Dest": 
        setFormForm(formForm => ({
          ...formForm,
          default_aut_dest_licenseplate:row.licenseplate
        }));
        break;
      case "Rel_Trans": 
        setFormForm(formForm => ({
          ...formForm,
          default_rel_trans_licenseplate:row.licenseplate
        }));
        break;
      case "Resp_Prod": 
        setFormForm(formForm => ({
          ...formForm,
          default_resp_prod_licenseplate:row.licenseplate
        }));
        break;
      default:
        break;
    } 
    handleCloseDataEditVehicles();
  };

  const listItems= (
  stableSort(dataVehicle, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, keydataVehicle) => {
    return (
      <TableRow hover tabIndex={-1} key={keydataVehicle}>
        {(row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <IconButton  size="large"  className="edit-select-button" onClick={()=>selectDefaultAddress(row)}>
              <PanToolAltIcon style={{fontSize: 28}}/>
            </IconButton>
          </TableCell>
        } 
        <TableCell align="left">
        <Typography style={{color:"#4e73df", fontSize: 16}} >
          {row.licenseplate}
        </Typography>  
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            <Checkbox checked={row.defaultvehicle} style={{color:"#4e73df", fontSize: 16}} 
               sx={{
                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
              }}
              disabled
            />
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
          {row.tara}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {row.pma}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            <Checkbox checked={row.checkpma} style={{color:"#4e73df", fontSize: 16}} 
              sx={{
                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
              }}
              disabled
            />
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {row.defaultdriver}
          </Typography>
        </TableCell>
      </TableRow>
    );
  }));
  
  return(
    <>
      <Box sx={{ width: '100%' }}>      
        <EnhancedTableToolbar numTotRegVehicles={numTotRegVehicles} t={t} titleTable={titleTable}/>
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '750px' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t}/>
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={6} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10,15]}
                    colSpan={12}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingTypesDIVehicles.propTypes = { 
  dataVehicle: PropTypes.array.isRequired, 
  numTotRegVehicles: PropTypes.number.isRequired,
  titleTable: PropTypes.string.isRequired,
  selectStores : PropTypes.string.isRequired,
  setFormForm : PropTypes.func.isRequired,
  handleCloseDataEditVehicles: PropTypes.func.isRequired
};

export default TableSortingTypesDIVehicles;